module.exports = __webpack_public_path__ + "assets/img/mecha-db4509c7.png";